/* eslint-disable promise/catch-or-return */
import $ from 'jquery';
import { toLocalizedRiotUrl } from './../utils/language';

function toInt(n) {
    return Math.round(Number(n)) | 0;
}

export default new (function() {
    this.calculateShipping = function(length, width, height, weight) {
        var deferred = $.Deferred();

        length = toInt(length);
        width = toInt(width);
        height = toInt(height);
        weight = toInt(weight);

        if (length && width && height && weight) {
            $.get(toLocalizedRiotUrl('/selling/shippingcalculator'), {
                length,
                width,
                height,
                weight
            })
                .then(deferred.resolve)
                .fail(deferred.reject);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    };
})();
